'use strict';
import { environment } from './environments/environment';

export const paginationSkip: number = 10;
export const paginationSkip100: number = 100;
export const baseAPI: string = environment.api;



// WEBPACK FOOTER //
// ./src/constants.ts